var _error = console.error;
import moment from "moment";
import axios from "@/services/axios";
import { logErrors } from "@/utils/appSettings";
import router from "@/router";
var queue = [];
window.onerror = function(){
    var token = sessionStorage.getItem("token");
    if (token != null) {
        queue.push({ dateTime: moment(new Date()).format(), arguments: JSON.stringify(arguments), token: token, route: router.currentRoute.path })
    }
}
console.error = function() {
var token = sessionStorage.getItem("token");
    if (token != null) {
        queue.push({ dateTime: moment(new Date()).format(), arguments: JSON.stringify(arguments), token: token, route: router.currentRoute.path })
    }
    _error.apply(console, arguments)
}


async function sendFirst() {
  var first = queue[0];
  var response = await axios.post("Utility/Log", first);
  if (response.status == 200) {
    queue.splice(0, 1);
  }
}
async function nextTick() {
  try {
    if (queue.length > 0) {
      await sendFirst();
    }
    if (queue.length > 5) {
      await sendFirst();
    }
    if (queue.length > 10) {
      var length = queue.length;
      queue.splice(parseInt(length / 2));
      console.error("LogQueueFull, remove half, count: " + length);
    }
  } catch (error) {
    _error.apply(console, error);
  }
  setTimeout(nextTick, 1000);
}

async function start() {
  var enabled = await logErrors();
  if (enabled) {
    nextTick();
  }
}

start();
